import { createSelector } from 'reselect';
const checkoutStateSelector = (state) => state.checkout;
export const makeGetCheckoutStatus = () => createSelector(checkoutStateSelector, (checkoutState) => checkoutState);
export const makeGetConfirmationError = () => createSelector(checkoutStateSelector, (checkoutState) => checkoutState.confirmationError);
export const makeGetConfirmationOrder = () => createSelector(checkoutStateSelector, (checkoutState) => checkoutState.confirmationOrder);
export const makeGetNewsletterPreferences = () => createSelector(checkoutStateSelector, (checkoutState) => checkoutState.newsletterPreferences);
